// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2025 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import checkoutSharedStyles from "@awc/App/SharedStyles/CheckoutSharedStyles";
import { checkoutReviewAndSubmitPaymentDetailsStyles } from "@awc/Overrides/Widgets/CheckoutReviewAndSubmit/CheckoutReviewAndSubmitPaymentDetails";
import { fontConfig } from "@awc/XDL/PreStyle/typography";
import { color } from "@awc/XDL/Utilities";
import { css } from "styled-components";

checkoutReviewAndSubmitPaymentDetailsStyles.title = {
    ...checkoutSharedStyles.sectionTitle,
};
checkoutReviewAndSubmitPaymentDetailsStyles.innerWrapper = {
    ...checkoutSharedStyles.sectionInnerContainer,
};
checkoutReviewAndSubmitPaymentDetailsStyles.poNumberGridItem = { width: 12 };
checkoutReviewAndSubmitPaymentDetailsStyles.paymentMethodGridItem = {
    width: 12,
    css: css`
        flex-direction: column;
        row-gap: 8px;
    `,
};
checkoutReviewAndSubmitPaymentDetailsStyles.paymentMethodAndPONumberContainer = {
    gap: 12,
    css: css`
            margin-bottom: 10px;
        `,
};

checkoutReviewAndSubmitPaymentDetailsStyles.creditCardDetailsGridItem = { width: 12 };
checkoutReviewAndSubmitPaymentDetailsStyles.paystandDetailsGridItem = { width: 12 };
checkoutReviewAndSubmitPaymentDetailsStyles.eCheckDetailsGridItem = { width: 12 };
checkoutReviewAndSubmitPaymentDetailsStyles.creditCardAddressGridItem = {
    width: 12,
    css: css`
            flex-direction: column;
        `,
};
checkoutReviewAndSubmitPaymentDetailsStyles.creditCardAddress = {
    heading: {
        forwardAs: "h3",
        css: css`
        margin-block: 12px 6px;
        `,
    },
    useBillingAddressCheckbox: {
        css: css`
           &&& label {
                color: ${color("text.main")};
                font-size: ${fontConfig.fontSize.small}px;
                line-height: ${fontConfig.lineHeight.singleLineSmall};
                font-weight: ${fontConfig.weight.bold};
            
            }
        `,
    }
}
